import { useSelector } from 'react-redux';
import { EarliestDate } from '~/contracts/vdp';
import { getDeliveryInfo, getPickupInfo } from '~/selectors';

const useGetEarliestDate = (): EarliestDate => {
  const delivery = useSelector(getDeliveryInfo);
  const pickup = useSelector(getPickupInfo);

  const deliveryIsSooner =
    (delivery?.utcSoonestDateTime || 0) < (pickup?.utcSoonestDateTime || 0);

  return {
    asSoonAsText: deliveryIsSooner
      ? delivery?.asSoonAsText
      : pickup?.asSoonAsText,
    earliestDate: deliveryIsSooner
      ? delivery?.utcSoonestDateTimeIso
      : pickup?.utcSoonestDateTimeIso,
    timeZone: deliveryIsSooner ? delivery?.localTimeZone : pickup?.localTimeZone
  };
};

export default useGetEarliestDate;
